@if (!user() || !survey) {
  <wa-callout variant="warning">
    <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
    <strong>No survey has been selected.</strong><br/>
    Please click on a survey on the left to see your assignments.
  </wa-callout>
} @else if (survey) {
  <div class="wa-stack wa-gap-xl">
    <app-supervision-list
      [user]="user()"
      [survey]="survey"
      [withoutStaffMember]="true">
    </app-supervision-list>
    <wa-divider></wa-divider>
    <app-correction-list
      [user]="user()"
      [survey]="survey"
      [withoutStaffMember]="true">
    </app-correction-list>
  </div>
}
